import Route from '@ember/routing/route';
import { service } from '@ember/service';

import { ME_LEGAL_CODES } from 'register-partners-js/models/register-organization';
import { MainLayout } from 'register-partners-js/react/components/layouts/main';

export default class CredentialsSuccessRoute extends Route {
  mainLayout = MainLayout;

  @service store;
  @service segment;
  @service router;

  model() {
    let registration = this.modelFor('registration');
    let organization = registration.get('organization');

    if (registration.isFastTrackWithoutCapitalDeposit) {
      this.segment.track('onboarding_partner_register_email_confirmed', {
        under_registration: false,
        is_company_creation_from_scratch: true,
        // The isFastTrackWithoutCapitalDeposit already narrows to ME or SC|I
        legal_form: ME_LEGAL_CODES.includes(organization.get('legalFormCreditSafeCode'))
          ? 'EI'
          : 'SC/I',
      });
    }

    return {
      organization,
      registration,
    };
  }
}
